import { render, staticRenderFns } from "./plus_details.vue?vue&type=template&id=1c16c459&scoped=true&"
import script from "./plus_details.vue?vue&type=script&lang=js&"
export * from "./plus_details.vue?vue&type=script&lang=js&"
import style0 from "./plus_details.vue?vue&type=style&index=0&id=1c16c459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c16c459",
  null
  
)

export default component.exports